import Leaflet from "leaflet";

export const inServiceDriverIcon = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/map-pointer.png"),
  iconRetinaUrl: require("../../../assets/images/map-pointer.png"),
  iconSize: [24, 24],
  iconAnchor: [12, 24],
  className: "icon-marker",
});
export const boyStudent = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/boy-student.png"),
  iconRetinaUrl: require("../../../assets/images/boy-student.png"),
  iconSize: [36, 36],
  iconAnchor: [18, 0],
  className: "icon-marker",
});
export const boyStudentApproved = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/boy-student-approved.png"),
  iconRetinaUrl: require("../../../assets/images/boy-student-approved.png"),
  iconSize: [36, 36],
  iconAnchor: [18, 0],
  className: "icon-marker",
});
export const girlStudent = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/girl-student.png"),
  iconRetinaUrl: require("../../../assets/images/girl-student.png"),
  iconSize: [32, 32],
  iconAnchor: [18, 0],
  className: "icon-marker",
});

export const girlStudentApproved = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/girl-student-approved.png"),
  iconRetinaUrl: require("../../../assets/images/girl-student-approved.png"),
  iconSize: [36, 36],
  iconAnchor: [18, 0],
  className: "icon-marker",
});

export const driverNotApprovedIcon = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/car-approved.png"),
  iconRetinaUrl: require("../../../assets/images/car-approved.png"),
  iconSize: [52, 26],
  iconAnchor: [18, 0],
  className: "icon-marker",
});
export const driverApprovedIcon = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/car-approved.png"),
  iconRetinaUrl: require("../../../assets/images/car-approved.png"),
  iconSize: [52, 26],
  iconAnchor: [18, 0],
  className: "icon-marker",
});
export const schoolIcon = new Leaflet.Icon({
  iconUrl: require("../../../assets/images/school.png"),
  iconRetinaUrl: require("../../../assets/images/school.png"),
  iconSize: [32, 32],
  iconAnchor: [18, 0],
  className: "icon-marker",
});
